import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(LanguageDetector) // Detect language from the browser
  .init({
    detection: {
        order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      },
      backend: {
        // path where resources get loaded from, relative to your public/index.html
        // in case of CRA (Create React App), the public folder is the root folder
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;

